
import {  gsap } from "gsap";
import { Helper } from "../../../dev/utils/Helper";
import { ReelState } from "../../../dev/reel/ReelEngineView";
import { ArrayHelper } from "../../../dev/utils/ArrayHelper";
import { GameSetting } from "../../../dev/setting/GameSetting";
import { Presentation, PresentationState } from "../../../dev/gameflow/controller/Presentation";

import { GameData } from "../../server/data/BaseModel";
import { ReelEngineManager } from "../../../dev/reel/ReelEngineManager";
import { ReelEngineController } from "../../../dev/reel/ReelEngineController";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { SoundManager } from '../../config/sound/SoundManager';
import { RoadRageEngineController } from '../../reel/RoadRageEngineController';
import { SoundConfig } from '../../config/sound/SoundConfig';
import { RoadRageEngineManager } from '../../reel/RoadRageEngineManager';
import { ScatterSymState } from '../../reel/symbol/RoadRageScatterLamps';
import { RoadRage } from '../../RoadRage';

export class StopPresentation extends Presentation {

    protected gameData: GameData;
    protected animationTl: gsap.core.Timeline;
    protected scatterPos: number[];
    protected countScatter: number = 0;

    protected possibleWin: boolean[][] = [];

    protected isFSSUPER: boolean = false;

    protected get basicStopDelay():number[]{

        let delay:number[] = this.possibleWin.length > 2 ? [0, 0.3, 0.7, 0.9, 1.1] : [0, 0.3, 0.6, 0.8, 1];

        if(RoadRageEngineManager.isQuickStop || GameSetting.isFastSpin){
            delay = GameSetting.isFastSpin ? delay.map(v => v*0.25) : [0, 0.01, 0.02, 0.03, 0.04]
        }

        return  delay;
    }
  
    setGamedData(data: GameData): void {
        this.countScatter = 0;
        this.gameData = data;
        this.isFSSUPER = this.gameData.mode === "FREESPIN_SUPER";
        this.scatterPos = data.Reel.scatterPositions;

        this.possibleWin = this.gameData.Win.CreateNearWinMap(data.Reel.lastStickies);

        if(this.possibleWin.length > 2){
            ArrayHelper.eachForEach(this.possibleWin,(reel,row) => {
                if(this.possibleWin[reel][row] && !data.Win.allBetWayWinData.reelWinPositions[reel][row]) this.possibleWin[reel][row] = false;
            })

            if( !this.possibleWin[0].find(() => true) || !this.possibleWin[1].find(() => true) )
                this.possibleWin = [];
        }

        ReelEngineManager.parseData(data.Reel);
    }

    preStart(): void {
        this.animationTl = Helper.setTimeline(this.animationTl, new gsap.core.Timeline());
    }

    // Add animation offset that couldn't be calculated.
    protected addAnimOffset(): void {
        if (this.animationTl.isActive()) {
            this.timeline.to(this, { duration: this.animationTl.duration() - this.animationTl.time() }, 0);
        }
    }

    // Add Start Offset.
    protected addStartReelOffset(): boolean {
        const remaining: number = ReelEngineManager.remainingStartEngineOffset();
        this.timeline.to(this, { duration: remaining }, 0);
        return !!remaining;
    }

    // Add animation offset that couldn't be calculated.
    protected addRemainingReelStop(): void {
        this.timeline.to(this, { duration: ReelEngineManager.lastSpinningTime || ReelEngineManager.remainingAnimatedReelTime }, 0);
    }

    protected createStopSpins(): void {
        ReelEngineManager.RAll((rc: ReelEngineController) => rc.createStop({
            stops: () => this.onStops(rc),
            bounce: () => this.onBounce(rc),
            stopped: () => this.onStopped(rc)
        }));
    }

    protected readyToDefineStop(): boolean {

        if (!this.PresentationState.isActive) {
            this.addAnimOffset();
            this.addRemainingReelStop();
            return false;
        }

        if (this.addStartReelOffset()) return false;

        this.PresentationState.setInactive();

        RoadRage.reelManager.miniCovering(false);
        return true;
    }

    playBounceSound(reelID: number): void {
        SoundManager.playReelStop(reelID);

        if (RoadRageEngineManager.lastStopOrder === reelID) {
            SoundManager.stopSoundEffect(SoundConfig.REELS_SPINNING);
        }
    }


    createPresentation(enableSkip: Function) {
        if (this.readyToDefineStop()) {
            this.createStopSpins();
            ReelEngineManager.stopReels(this.defineDelays());
        }
    }

    protected defineDelays(): number[] {
        return this.basicStopDelay;
    }

    protected onStops(rc: ReelEngineController): void { rc.setGraphAlpha(0, rc.stopDuration); }

    protected onBounce(rc: ReelEngineController): void { }

    protected onStopped(rc: ReelEngineController): void { }

    skip(): void {
        this.PresentationState.set(PresentationState.ACTIVATED);
        RoadRageEngineManager.isQuickStop = true;
        super.skip();
    }

    scatterLvlState(lvl: number) {
        return [ScatterSymState.LEVEL_1, ScatterSymState.LEVEL_2, ScatterSymState.LEVEL_3, ScatterSymState.LEVEL_4, ScatterSymState.LEVEL_5][lvl]
    }

    protected possibleWinNonWins(reelID: number): void {
        if (RoadRageEngineManager.isQuickStop || GameSetting.isFastSpin){
            if(RoadRageEngineManager.isQuickStop && reelID > 1) {
                for (let rec: number = 0; rec <= reelID; rec++) {
                    RoadRageEngineManager.getReel(rec).AllWindowSymbols.forEach((s,row) => {
                        if (s.isNormalSym) s.markNonWin(false, 0, 0.1);
                    })
                }
            }
            return;
        } 
        if (reelID > 1 && this.possibleWin.length > 2) {

            const alpha = 0.55;
            const durr = 0.6;

            if (reelID == 2) {
                for (let rec: number = 0; rec <= reelID; rec++) {
                    RoadRageEngineManager.getReel(rec).AllWindowSymbols.forEach((s,row) => {
                        s.markNonWin(!this.possibleWin[rec][s.posID[0]], alpha, durr);
                    })
                }
            }
            else if (this.possibleWin[reelID] && this.possibleWin[reelID].length) {
                RoadRageEngineManager.getReel(reelID).AllWindowSymbols.forEach((s,row) => {
                    if(!this.possibleWin[reelID][s.posID[0]]) s.markNonWin(true, alpha, durr);
                })
            }
            else {
                RoadRageEngineManager.getReel(reelID).AllWindowSymbols.forEach((s,row) => {
                    if (s.isNormalSym) s.markNonWin(true, alpha, durr);
                })
            }
        }
    }

    onScatterHits(rc: RoadRageEngineController) {
        if (this.scatterPos[rc.reelID] >= 0) {
            
            const animStart: number = this.animationTl.time();
            const scattLvl:number = this.countScatter;

            for (let reel: number = 0; reel <= rc.reelID; reel++) {
                if (this.scatterPos[reel] >= 0) {
                    this.animationTl.add( () => {
                        RoadRageEngineManager.getReel(reel).getSymbol(this.scatterPos[reel])!.scatterState(this.scatterLvlState(scattLvl))
                    }, animStart);
                    this.animationTl.to(this,{duration:0.1},animStart);
                }
            }
            SoundManager.playScatterLand(this.countScatter, !this.countScatter && RoadRageEngineManager.lastStopOrder == rc.reelID );
            this.countScatter++;
        }
    }

    isFinished(): boolean {
        const notFinished: boolean = !(ReelEngineManager.getFirstStoppingReel() >= 0 || ReelEngineManager.findReelWithState(ReelState.STEP) >= 0)
        if (!notFinished) return notFinished;

        if (this.animationTl.isActive()) return false;

        return true;
    }

    done() {
        Logger.log("Stop Done")
    }
}